const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];
const STORAGE_KEY = 'utm_params_session';

export function getUTMParamsFromURL(): Record<string, string> {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams: Record<string, string> = {};

  UTM_KEYS.forEach((key) => {
    const value = urlParams.get(key);

    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
}

export function persistUTMParams() {
  const utms = getUTMParamsFromURL();

  if (Object.keys(utms).length > 0) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  }
}

export function getStoredUTMParams(): Record<string, string> {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
}
